import React from 'react'
import { MEGA_MENU_CSS } from './megaMenuCruises.css.js'

const SITE_HOST = (() => {
  try { return new URL(window.wpData?.siteUrl ?? '').hostname } catch {}
  return window.location.hostname
})()

const BRANDS = [
  { value: 'ljn',    label: 'Le Journey Cruises' },
  { value: 'amanda', label: 'Amanda Cruises' },
  { value: 'hera',   label: 'Hera Cruises' },
]

function StarIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  )
}

function ThumbPlaceholder() {
  return (
    <svg width="32" height="24" viewBox="0 0 30 22" fill="none">
      <rect x="1" y="1" width="28" height="20" rx="1" stroke="rgba(245,242,236,0.3)" strokeWidth="0.8"/>
      <path d="M1 14l7-6 5 5 5-4 7 7" stroke="rgba(201,165,106,0.45)" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="21" cy="7" r="2.5" stroke="rgba(201,165,106,0.45)" strokeWidth="0.8"/>
    </svg>
  )
}

function CruiseCard({ cruise }) {
  const stars  = parseInt(cruise.stars)  || 0
  const cabins = parseInt(cruise.cabins) || 0
  let isExternal = false
  try { isExternal = !!cruise.url && new URL(cruise.url).hostname !== SITE_HOST } catch {}
  return (
    <a
      href={cruise.url || '#'}
      className="mm-cruise-card"
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      <div className="mm-cruise-card__thumb">
        {cruise.thumb
          ? <img src={cruise.thumb} alt={cruise.title} />
          : <ThumbPlaceholder />
        }
      </div>
      <div>
        <div className="mm-cruise-card__name">{cruise.title}</div>
        <div className="mm-cruise-card__meta">
          {stars > 0 && (
            <span className="mm-cruise-card__stars">
              {Array.from({ length: stars }, (_, i) => <StarIcon key={i} />)}
            </span>
          )}
          {stars > 0 && <span className="mm-cruise-card__dot">·</span>}
          <span className="mm-cruise-card__cabins">{cabins > 0 ? `${cabins} cabins` : 'Day Cruise'}</span>
        </div>
      </div>
    </a>
  )
}

export default function MegaMenuCruises({ open, onMouseEnter, onMouseLeave, scrolled }) {
  const cruises = window.wpData?.cruises ?? []

  const grouped = BRANDS.map(b => ({
    ...b,
    cruises: cruises.filter(c => c.brand === b.value),
  })).filter(b => b.cruises.length > 0)

  return (
    <>
      <style>{MEGA_MENU_CSS}</style>
      <div
        className={`mm-cruises${open ? ' mm-cruises--open' : ''}${scrolled ? ' mm-cruises--solid' : ''}`}
        role="menu"
        aria-label="Explore all cruises"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {grouped.length === 0 ? (
          <p style={{ color: 'rgba(245,242,236,0.4)', fontSize: 13, margin: 0 }}>
            No cruises configured yet.
          </p>
        ) : (
          <div className="mm-cruises__grid">
            {grouped.map(brand => (
              <div key={brand.value} className="mm-cruises__brand">
                <div className="mm-cruises__brand-label">{brand.label}</div>
                <div className="mm-cruises__list">
                  {brand.cruises.map(cruise => (
                    <CruiseCard key={cruise.id} cruise={cruise} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
